export const fieldsValidators = {
  lettersWithSpaces: /^([a-zA-Z]+\s*)*$/,
  letterRequired: /[a-zA-Z]/,
  intPercentage: /^0*(0|[1-9][0-9]?|100)%?$/,
  decimalPercentage: /^0*((0|[1-9][0-9]?)([.]\d{0,4})?|100)%?$/,
  alphanumeric: /^[a-zA-Z0-9]*$/,
  // HTML and other markup fail this pattern.
  textBoxValue: /^(?=.*\p{L})[\p{L}\p{M}0-9\s.'’&,()/-]+$/u,
};
